import { Directive, Input, WritableSignal, effect } from '@angular/core';
import { SdControlValueAccessorDirective } from './sd-control-value-accessor.directive';

@Directive({ selector: '[wctSdSignalModel]', standalone: true, providers: [SdSignalModelDirective] })
export class SdSignalModelDirective<TComponent = object> extends SdControlValueAccessorDirective<TComponent> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input({ alias: 'wctSdSignalModel', required: true }) public signal!: WritableSignal<any>;

  constructor() {
    super();
    this.registerOnChange(value => {
      this.signal.set(value);
    })
    effect(() => {
      this.writeValue(this.signal());
    })
  }
}
